import React, { useState } from "react";
import logofooter from "./assets/image/Lion Touch logo white.png";
import { Link } from "react-router-dom";
import firebaseApp from "./Firecontact";
import ScrollToTop from "./ScrollToTop";
import WhatsAppBtn from "./WhatsAppBtn";

// import { ToastContainer, toast } from 'react-toastify';

let edata = [];

const Footer = () => {
    const [email, setEmail] = useState("");
    const [, SetOnlyemil] = useState([]);

    const validateEmail = (email) => {
        // Use a regex pattern for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const Onlyemail = () => {
        // toast("Your Account is Created");
        let onlymail = {
            Email: email,
            id: Date.now(),
            Date: Date(),
        };

        if (!validateEmail(email)) {
            alert("Please enter a valid email address");
            return;
        }
        edata.push(onlymail);
        console.log(onlymail);

        // toast("We will Reply Soon");

        let db = firebaseApp.firestore();
        db.collection("subcribe")
            .add(onlymail)
            .then((docRef) => {
                console.log("Document written with ID: ", docRef.id);
            })
            .catch((error) => {
                console.error("Error adding document: ", error);
            });

        SetOnlyemil(edata);
        setEmail("");
    };

    const today = new Date();
    const year = today.getFullYear();
    return (
        <div>
            {/* <ToastContainer /> */}
            {/* <!--====== FOOTER PART START ======--> */}
            <footer className="footer-area px-3 px-md-0">
                <div className="widget-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-md-7">
                                <div className="footer-widget text-center text-md-start">
                                    <Link to={"/Home"} className="d-inline-block mb-4">
                                        <img
                                            src={logofooter}
                                            alt="Liontouch Webpark"
                                            className="w-75"
                                        />
                                    </Link>
                                    <p className="text-white mb-25">
                                        Start advertising your Business opportunity & You can Grow
                                        your Business With Liontouch Webpark
                                    </p>
                                    <ul className="social d-flex  ps-0 justify-content-center justify-content-md-start">
                                        <li>
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href="https://api.whatsapp.com/send?phone=+918849858625&amp;text=Hi+Liontouch+Webpark,+I+want+some+more+information+about+your+services.+Please+reply+soon."
                                            >
                                                <i className="lni lni-whatsapp "></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href="https://www.facebook.com/profile.php?id=61563096922232&sk=about_overview"
                                            >
                                                <i className="lni lni-facebook-original"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href="https://www.instagram.com/liontouch_webpark?igsh=MTB4ZWU3ZmNiY3pwdA=="
                                            >
                                                <i className="lni lni-instagram-original"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                href="https://www.linkedin.com/in/liontouch-webpark-a45a052b2"
                                            >
                                                <i className="lni lni-linkedin-original"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-4 order-md-3 order-xl-2 col-sm-6 ">
                                <div className="footer-widget">
                                    <h4>Information</h4>
                                    <ul className="link ps-0">
                                        <li>
                                            <Link to={"/Services"}>App Development</Link>
                                        </li>
                                        <li>
                                            <Link to={"/Services"}>Web Developmernt</Link>
                                        </li>
                                        <li>
                                            <Link to={"/Services"}>Business Branding</Link>
                                        </li>
                                        <li>
                                            <Link to={"/Services"}>Marketing Services</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-4 order-md-2 order-xl-1 col-sm-6 ps-2 ps-md-5">
                                <div className="footer-widget">
                                    <h4>About Us</h4>
                                    <ul className="link ps-0">
                                        <li>
                                            <Link to={"/Services"}>Services</Link>
                                        </li>
                                        {/* <li><Link to={'/Product'}>Product</Link></li> */}
                                        <li>
                                            <Link to={"/About-us"}>About Us</Link>
                                        </li>
                                        <li>
                                            <Link to={"/Blog"}>Blog</Link>
                                        </li>
                                        <li>
                                            <Link to={"/Career"}>Career</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-4 order-md-4 order-xl-3 col-sm-6 ">
                                <div className="footer-widget">
                                    <h4>Support</h4>
                                    <ul className="link ps-0 ">
                                        <li>
                                            <Link to={"/Contact"}>Contact Us</Link>
                                        </li>
                                        <li>
                                            <a
                                                href="https://api.whatsapp.com/send?phone=+918849858625&amp;text=Hi+Liontouch+Webpark,+I+want+some+more+information+about+your+services.+Please+reply+soon."
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Live Support
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/About-Us#faq">FAQ</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-5 order-md-1 order-xl-4 col-sm-6 ">
                                <div className="footer-widget">
                                    <h4>Are You A Business Man?</h4>
                                    <ul className="ps-0">
                                        <li>
                                            <h6 className="text-white">Subscribe To Our Newsletter</h6>
                                        </li>
                                        <div className="input-group mb-3">
                                            <input
                                                className="form-control"
                                                type="email"
                                                placeholder="Enter Email Id"
                                                onChange={(e) => setEmail(e.target.value)}
                                                value={email}
                                                aria-label="Recipient's username"
                                                aria-describedby="button-addon2"
                                            />
                                            <button
                                                className="btn text-light "
                                                onClick={Onlyemail}
                                                style={{ backgroundColor: "#f15a25" }}
                                                id="button-addon2"
                                                type="button"
                                            >
                                                <i className="lni lni-arrow-right"></i>
                                            </button>
                                        </div>
                                        <li className="mt-2 text-white">
                                            <a href="tel:+918849858625" className="text-white">
                                                <i className="lni lni-phone me-2"></i>+91 884 985 8625
                                            </a>
                                        </li>
                                        <li className="mt-1 text-white">
                                            <a
                                                href="mailto:liontouchwebpark@gmail.com"
                                                className="text-white"
                                            >
                                                <i className="lni lni-envelope me-2"></i>
                                                liontouchwebpark@gmail.com
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="container-fluid bg-grey">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="text-center py-2">
                            <p className="mb-0">
                                Copywrite © {year} all rights reserved by{" "}
                                <a href="/">Liontouch Webpark.</a>{" "}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <ScrollToTop />
            <WhatsAppBtn />
        </div>
    );
};

export default Footer;
